const user_workflows = {
    title: "My Workflows",
      saved: "Workflow saved.",
      deleted: "Workflow deleted.",
}

export default user_workflows;